import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { Edit2, Trash } from "iconsax-reactjs";
import ConfirmModal from "../message/ConfirmModal";
import { deleteGoldenChallengeChain } from "../../../services/webServices/challenge/delete";
import type { GoldenChallengeChain } from "../../../services/webServices/challenge/types";

type Props = {
  chain: GoldenChallengeChain;
  onActionSuccessed: () => void;
};

export default function ChallengeChainAction({ chain, onActionSuccessed }: Props) {
  const navigate = useNavigate();
  const [isConfirmOpen, setIsConfirmOpen] = useState<boolean>(false);
  const [isDeleting, setIsDeleting] = useState<boolean>(false);

  const handleDelete = async () => {
    if (isDeleting) return;

    setIsDeleting(true);
    const success = await deleteGoldenChallengeChain({ id: chain.id });
    setIsDeleting(false);
    setIsConfirmOpen(false);

    if (!success) {
      toast.error("حذف زنجیره با خطا مواجه شد");
      return;
    }

    toast.success("زنجیره با موفقیت حذف شد");
    onActionSuccessed();
  };

  return (
    <div className="flex items-center justify-center gap-2">
      <button
        type="button"
        title="ویرایش"
        onClick={() =>
          navigate(`/challenge/${chain.id}/edit`, { state: { chain } })
        }
        className="p-1.5 rounded-lg text-gray-500 hover:text-primaryVar-500 hover:bg-primaryVar-50 transition-colors"
      >
        <Edit2 size={18} variant="Outline" />
      </button>

      <button
        type="button"
        title="حذف"
        disabled={isDeleting}
        onClick={() => setIsConfirmOpen(true)}
        className="p-1.5 rounded-lg text-gray-500 hover:text-errorVar-500 hover:bg-errorVar-light transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
      >
        <Trash size={18} variant="Outline" />
      </button>

      <ConfirmModal
        isOpen={isConfirmOpen}
        onClose={() => setIsConfirmOpen(false)}
        type="confirmation"
        title="تأیید حذف زنجیره"
        message="آیا مطمئن هستید که می‌خواهید این زنجیره را حذف کنید؟ این عمل قابل بازگشت نیست."
        primaryAction={{
          text: isDeleting ? "در حال حذف..." : "بله، حذف کن",
          onClick: handleDelete,
          variant: "danger",
        }}
        secondaryAction={{
          text: "انصراف",
          onClick: () => setIsConfirmOpen(false),
        }}
      />
    </div>
  );
};
